import { ERoomsTotal } from '../../../../api-models/common/json_query';

export const ROOMS_TOTAL_MAP_VALUE_TO_LABEL = {
  [ERoomsTotal.Any]: '',
  [ERoomsTotal.One]: 'от 1',
  [ERoomsTotal.Two]: 'от 2',
  [ERoomsTotal.Three]: 'от 3',
  [ERoomsTotal.Four]: 'от 4',
  [ERoomsTotal.Five]: 'от 5',
};
